import React, { ReactNode } from 'react';
import { Box } from '@mui/material';
import './CardGrid.css';

export interface CardGridProps {
  children: ReactNode;
  minCardWidth?: string;
  gap?: string;
}

const CardGrid: React.FC<CardGridProps> = ({
  children,
  minCardWidth = '245px',
  gap = 'var(--palette-light-4-value)', // 16px
}) => {
  return (
    <Box
      className="card-grid"
      sx={{
        display: 'grid',
        gridTemplateColumns: `repeat(auto-fill, minmax(${minCardWidth}, 1fr))`,
        gap,
        flex: 1,
        overflowY: 'auto',
        overflowX: 'hidden',
        paddingRight: 'var(--palette-light-4-value)', // 16px for scrollbar
        '&::-webkit-scrollbar': {
          width: '6px',
        },
        '&::-webkit-scrollbar-track': {
          backgroundColor: 'var(--palette-light-background-secondary-value-hex)',
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: 'var(--palette-light-text-tertiary-value-hex)',
          borderRadius: '4px',
        },
      }}
    >
      {children}
    </Box>
  );
};

export default CardGrid;

